import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Thread } from '../../timeline-item';

@Component({
    selector: 'tm-thread-message-under-moderation',
    templateUrl: './thread-message-under-moderation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TranslateModule
    ]
})
export class ThreadMessageUnderModeration {
    @Input() thread: Thread;
}